const s = "Ultrabook-Auth-Sdk", i = "https://hub.leyantech.com", c = {
  请求失败: "0",
  token解析错误: "1",
  token丢失: "2",
  请求超时: "3",
  message通信失败: "4",
  超极本子域名错误: "5",
  iframe窗口对象不存在: "6",
  超极本发送消息类型不存在: "7",
  子应用域名错误: "8",
  子应用发送消息类型不存在: "9"
}, g = {
  重新授权: "renewTokenMother",
  发生错误: "hasError"
}, d = 600;
let n = null;
function f(r) {
  const {
    subAppOrigin: l = window.location.origin,
    onRenewToken: a,
    onError: o
  } = r, t = (e) => {
    if (e.origin !== i) {
      o({ code: d, data: c.超极本子域名错误 });
      return;
    }
    const {
      data: { action: u, data: p }
    } = e;
    switch (u) {
      case "renewTokenMother": {
        a(p.data);
        break;
      }
      case "hasError": {
        o(p);
        break;
      }
      default:
        o({
          code: d,
          data: c.超极本发送消息类型不存在
        });
        break;
    }
  }, w = () => {
    const e = document.getElementById(s)?.contentWindow;
    if (e) {
      e.postMessage(
        {
          action: "renewTokenApp"
        },
        i
      );
      return;
    }
    o({ code: d, data: c.iframe窗口对象不存在 });
  }, m = (e) => {
    n = setInterval(() => {
      w();
    }, (e || 10) * 1e3);
  }, h = () => {
    n && clearInterval(n);
  };
  return window.onload = () => {
    window.addEventListener("message", t, !1);
    const e = document.createElement("iframe");
    e.style.display = "none", e.title = s, e.id = s, e.width = "0", e.height = "0", e.src = `${i}/console-storage/?subAppOrigin=${l}`, document.body.appendChild(e);
  }, window.onbeforeunload = () => {
    window.removeEventListener("message", t), n && clearInterval(n);
  }, {
    watchTokenExpired: m,
    stopWatchTokenExpired: h
  };
}
const k = (r) => {
  const a = r.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"), o = decodeURIComponent(
    window.atob(a).split("").map(function(t) {
      return "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2);
    }).join("")
  );
  return JSON.parse(o);
};
export {
  d as APP_ERROR_CODE,
  c as ErrorReason,
  g as MotherAction,
  k as decode,
  f as ultrabookAuth
};
